// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"vs_a bhb_b"};